import React from 'react';
import classNames from 'classnames';
import { IconCopyL, IconCheckmarkL, IconExportL } from '../../icons';
import { useCopyToClickBoard } from '../../hooks/useCopyToClickBoard';

import css from './CopyToClickBoard.css';
import Button from '../Button/Button';

export default ({
    actionString,
    actionStrRepresentation,
    isPlainLink,
    rootClassName,
    queryParams,
}) => {
    const { copied, copyToClickBoard } = useCopyToClickBoard();

    const getNavigationUri = () => {
        if (!queryParams) return actionString;
        const qp = new URLSearchParams(queryParams);
        return `${actionString}?${qp.toString()}`;
    };

    const voucherLinkActionButton = (
        <Button
            className={classNames(css.voucherCode, css.linkType, {
                [rootClassName]: !!rootClassName,
            })}
            type="button"
            onClick={() => window.open(getNavigationUri(), '_blank', 'nofollow')}
        >
            Zum Angebot <IconExportL />
        </Button>
    );

    return isPlainLink ? (
        voucherLinkActionButton
    ) : (
        <p
            className={classNames(css.voucherCode, {
                [css.copied]: copied,
                [css.voucherType]: true,
                [rootClassName]: !!rootClassName,
            })}
            onClick={() => copyToClickBoard(actionString)}
        >
            <span>{actionStrRepresentation || actionString}</span>{' '}
            {copied ? <IconCheckmarkL /> : <IconCopyL />}
        </p>
    );
};
